import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "prod-discount__text" };
const _hoisted_2 = ["data-id"];
import DiscountNote from "./DiscountNote.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NoDiscountInfo',
    props: {
        id: { type: Number, required: true },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DiscountNote, null, {
                default: _withCtx(() => [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "prod-discount__title" }, "Хотите узнать первым о скидках на этот товар?", -1 /* CACHED */)),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("button", {
                            class: "link link--dashed win",
                            "data-act": "ask_discount",
                            "data-id": __props.id,
                            type: "button"
                        }, "Оставьте вашу эл. почту", 8 /* PROPS */, _hoisted_2),
                        _cache[0] || (_cache[0] = _createTextVNode("\n      и мы сообщим вам о скидке\n    ", -1 /* CACHED */))
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
